module.exports = __webpack_public_path__ + "img/ennetix-users-tab2.932d3796.png";